function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));

    this.querySelectorAll('.quantity__input').forEach((input) => 
      input.addEventListener('keypress', this.onEnterPress.bind(this))
    );

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onEnterPress(e) {
    if (e.which === 13 || e.keyCode === 13) {
      e.preventDefault();

      dispatchEvent(this.changeEvent);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if ((parseInt(this.input.dataset.min) > parseInt(this.input.step)) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp()
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if ((this.input.dataset.min === previousValue) &&  event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }


  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked &&
      this.desktopLayout.matches
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();


    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
     /* this.updateMedia(); */
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.dispatchVariantUpdateEvent()
      this.updateSelectedVariantName()
      let skioPickers = document.querySelectorAll('skio-plan-picker');
      skioPickers.forEach(skio => {
        if (skio) {
          skio.selectedVariant = this.currentVariant;
        }
      });
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
     /*
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
    products are only using magnaify option, so this function is irrelevent now
    */
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  dispatchVariantUpdateEvent() {
    const variantUpdateEvent = new CustomEvent('variantUpdated', {
      bubbles: true,
      detail: {
        variant: this.currentVariant,
      },
    });
    this.dispatchEvent(variantUpdateEvent);
  }

  updateSelectedVariantName() {
    const currentVariantTextElement = document.querySelector('[data-product-form-current-color-variant-text]')
    if (!currentVariantTextElement) return;
    const {id} = this.currentVariant ?? {}
    currentVariantTextElement.innerText = this.currentVariant.title?.split('(')[0];
    const variantMetafieldJson = document.querySelector(`[data-variant-metafield-list]`)
    if (!variantMetafieldJson) return;
    const variantMetafieldList = JSON.parse(variantMetafieldJson.innerText)
    const variantMetaObject = variantMetafieldList[id]
    if (!variantMetaObject) return;
    const variantLabelText = document.querySelector('[data-product-form-current-color-variant-label-text]')
    if (!variantLabelText) return;
    variantLabelText.innerText = variantMetaObject.variantLabel
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class VariantSwatches extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-swatches', VariantSwatches);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    this.assignMenuListeners();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }

  setFocusToMegaMenu = (wrap) => {
    const focussableEls = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    const focusableElements = wrap.querySelectorAll(focussableEls)
    const visibleEls = Array.from(focusableElements).filter( (el) => el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0)
    if (visibleEls && visibleEls.length > 0) visibleEls[0].focus()
  }

  resetMenuState = () => {
    const headerDropdownMenu = document.querySelectorAll('.header-dropdown-menu')
    headerDropdownMenu && headerDropdownMenu.forEach((item) => {
      item.style.display = 'none'
      item.classList.remove('active-menu')
    })
  }

  escListener = (targetDropdownId) => {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.resetMenuState()
        const activeMegaMenuButtons = document.querySelector(`.header-nav-title[data-dropdown="${targetDropdownId}"]`)
        if (activeMegaMenuButtons) {
          activeMegaMenuButtons.focus()
        }
      }
    })
  }

  lastSelectableElementListener = (wrap, targetDropdownId) => {
    const focusableElsSelector = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    const focusableElements = wrap.querySelectorAll(focusableElsSelector)
    const visibleEls = Array.from(focusableElements).filter(el => el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0)

    if (visibleEls.length > 0) {
        const lastElement = visibleEls[visibleEls.length - 1]
        lastElement.addEventListener('keydown', (e) => {
            if (e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault()
                this.resetMenuState()
                const activeMegaMenuButtons = document.querySelector(`.header-nav-title[data-dropdown="${targetDropdownId}"]`)
                if (activeMegaMenuButtons) {
                  activeMegaMenuButtons.focus()
                }
            }
        })
    }
  }

  assignMenuListeners() {
    const allDropdowns = this.querySelectorAll('.header-menu-dropdown-container [data-dropdown]')
  
    const hideAllDropdowns = (showDropDown, group) => {
      allDropdowns.forEach(dropdown => {
        let thisDropDown = dropdown.getAttribute('data-dropdown')
        if (showDropDown !== thisDropDown && dropdown.closest(`#${group}`)) {
          dropdown.style.display = 'none'
        }
      })
    }
  
    const setupMenuListeners = (navGroup, menuGroup) => {
      navGroup.querySelectorAll('.header-nav-title').forEach((title) => {
        let startX, startY
        let hoverTimeout
        const targetDropdownId = title.getAttribute('data-dropdown')
        const targetDropdown = menuGroup.querySelector(`[data-dropdown="${targetDropdownId}"]`)
  
        title.addEventListener('mouseenter', (e) => {
          clearTimeout(hoverTimeout)
          hoverTimeout = setTimeout(() => {
            let showDropDown = targetDropdown.getAttribute('data-dropdown')
            hideAllDropdowns(showDropDown, menuGroup.id)
    
            startX = e.clientX
            startY = e.clientY
            targetDropdown.style.display = 'block'
    
            document.addEventListener('mousemove', trackMouse)
          }, 500)
        })
        
        title.addEventListener('mouseleave', () => {
          clearTimeout(hoverTimeout)
        })
  
        targetDropdown.addEventListener('mouseenter', () => {
          clearTimeout(hoverTimeout)
          document.removeEventListener('mousemove', trackMouse)
        })
  
        targetDropdown.addEventListener('mouseleave', () => {
          targetDropdown.style.display = 'none'
        })
  
        const trackMouse = (e) => {
          const moveX = e.clientX - startX
          const moveY = e.clientY - startY

          if (moveX < -100 || moveY < -100) {
            clearTimeout(hoverTimeout)
            targetDropdown.style.display = 'none'
            document.removeEventListener('mousemove', trackMouse)
          }
        }
      })
    }
  
    const navGroup = this.querySelector('#header-nav-menu-group-original')
    const menuGroup = this.querySelector('#header-mega-menu-group-original')
    if (navGroup && menuGroup) {
      setupMenuListeners(navGroup, menuGroup)
    }
  
    const navGroupAlt = this.querySelector('#header-nav-menu-group-alternative')
    const menuGroupAlt = this.querySelector('#header-mega-menu-group-alternative')
    if (navGroupAlt && menuGroupAlt) {
      setupMenuListeners(navGroupAlt, menuGroupAlt)
    }
  }  
}

customElements.define('sticky-header', StickyHeader);

class RecentlyViewed extends HTMLElement {
  RECENTLY_VIEWED_TILE_TEMPLATE = `
<div class="swiper-slide slide">
  <div class="card card--standard card--media" style="--ratio-percent: 100%;">
      <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100%;">
          <div class="card__media newAspectRatio ">
              <div class="media media--transparent media--hover-effect">
                  <img src="[PRODUCT_IMAGE]" alt="[PRODUCT_TITLE] | [BRAND] | Credo Beauty" class="motion-reduce" loading="lazy" width="1080" height="1080">
              </div>
          </div>
          <div class="card__content newAspectRatio">
              <div class="card__information">
                  <h3 class="card__heading">
                      <a href="[PRODUCT_URL]" class="full-unstyled-link">[PRODUCT_TITLE]</a>
                  </h3>
              </div>
              <div class="NewBadge card__badge bottom left"></div>
          </div>
      </div>
      <div class="card__content ">
          <div class="card__information newCardInformation">
              <div class="card-information">
                  <span class="visually-hidden">Vendor:</span>
                  <div class="caption-with-letter-spacing light newVendor ">[BRAND]</div>
              </div>
              <h3 class="card__heading newCardHeading h5">
                  <a href="[PRODUCT_URL]" class="full-unstyled-link">[PRODUCT_TITLE]</a>
              </h3>
              <div class="price newPrice">
                  <div class="price__container">
                      <div class="price__regular">
                          <span class="visually-hidden visually-hidden--inline">Regular price</span>
                          <span class="price-item price-item--regular" price-for="[PRODUCT_PH]" collection-for="[PRODUCT_COLLECTIONS]">[PRODUCT_PRICE]</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>`

  constructor() {
    super();
  }

  connectedCallback() {
    this.recordRecentlyViewed()
    requestAnimationFrame(() => {
      this.renderRecentlyViewed()
    })
  }

  recordRecentlyViewed() {
    const curProduct = window.recentlyViewedPdpData

    let curItems = JSON.parse(localStorage.getItem('recentlyViewedItems') || "[]")

    // remove if already in the list
    // if (curItems.length === 0) return
    const curListIndex = curItems.findIndex(item => item.productHandle === curProduct.productHandle);
    if (curListIndex !== -1) {
      curItems.splice(curListIndex, 1);
    }

    // add to top of the list
    curItems.unshift(curProduct);

    // filter to latest 10
    if (curItems.length > 10) {
      curItems = curItems.filter((_, index) => index < 10);
    }

    localStorage.setItem('recentlyViewedItems', JSON.stringify(curItems))
  }

  findClosestSection(el) {
    while (el && el.parentNode) {
      el = el.parentNode
      if (el.tagName && el.tagName.toLowerCase() === 'section') {
        return el
      }
    }
    return null
  }

  renderRecentlyViewed() {
    const curProduct = window.recentlyViewedPdpData
    const recentlyViewedItems = JSON.parse(localStorage.getItem('recentlyViewedItems') || "[]")

    // if there's no items no need to render anything!
    if (recentlyViewedItems.length === 0) {
      this.findClosestSection(this).remove()
      return
    }

    // if this product is the only item in recentlyViewedItems, let's just close up shop man
    const curListIndex = recentlyViewedItems.findIndex(item => item.productHandle === curProduct.productHandle);
    if (curListIndex === 0 && recentlyViewedItems.length === 1) {
      this.findClosestSection(this).remove()
      return
    }

    for (let i = 0; i < recentlyViewedItems.length; i++) {
      const curItem = recentlyViewedItems[i]

      if (curItem.productHandle === curProduct.productHandle) {
        continue
      }

      const newTile = document.createElement('div')

      let template = this.RECENTLY_VIEWED_TILE_TEMPLATE
      template = template.replace(/\[PRODUCT_IMAGE\]/g, curItem.productImg)
      template = template.replace(/\[PRODUCT_TITLE\]/g, curItem.productTitle)
      template = template.replace(/\[BRAND\]/g, curItem.productVendor)
      template = template.replace(/\[PRODUCT_URL\]/g, curItem.productUrl)
      template = template.replace(/\[PRODUCT_PH\]/g, curItem.productHandle)
      template = template.replace(/\[PRODUCT_COLLECTIONS\]/g, curItem.productCollections)
      template = template.replace(/\[PRODUCT_PRICE\]/g, curItem.productPrice)

      newTile.innerHTML = template

      this.appendChild(newTile.firstElementChild)
    }
  }
}

customElements.define('recently-viewed', RecentlyViewed);

class StyledCheckbox extends HTMLElement {
  static get observedAttributes() {
    return ['name'];
  }

  constructor() {
    super();

    // Checkbox UI Template
    const template = document.createElement('template');
    template.innerHTML = `
      <label class="custom-checkbox">
        <input type="checkbox" class="actual-checkbox" />
        <span class="checkbox-ui">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none">
            <path stroke="#fff" stroke-linecap="round" stroke-width="1.5" d="m1 5 2.4 3L9 1"/>
          </svg>
        </span>
        <span class="checkbox-caption"></span>
      </label>
    `;

    this.appendChild(template.content.cloneNode(true));
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'name') {
        const checkbox = this.querySelector('.actual-checkbox');
        checkbox.setAttribute('name', newValue);
    }

    if (name === 'name') {
        const checkbox = this.querySelector('.actual-checkbox');
        checkbox.setAttribute('name', newValue);
    }
  }

  connectedCallback() {
    // Attach event listener to checkbox
    const checkbox = this.querySelector('.actual-checkbox');
    checkbox.addEventListener('change', function() {
      if (this.checked) {
        document.querySelector("#am-holder").value = true;
        this.setAttribute('selected', 'selected');
      } else {
        document.querySelector("#am-holder").value = false;
        this.removeAttribute('selected');
      }
    });

    // Transfer the caption from light DOM to checkbox-caption
    const caption = this.querySelector('.checkbox-caption');
    const slotCaption = this.querySelector('span[slot="caption"]')
    if (caption && slotCaption) {
      caption.appendChild(slotCaption.cloneNode(true))
      slotCaption.remove()
    }
  }
}

customElements.define('styled-checkbox', StyledCheckbox);




// window.nostoExperimentHeaderActive = async function () {

//   // Hide elements - Desktop
//   const originalHeaderMenu = document.querySelector('#header-nav-menu-group-original')
//   const originalHeaderMegaMenu = document.querySelector('#header-mega-menu-group-original')
//   if (originalHeaderMenu) originalHeaderMenu.style.display = 'none'
//   if (originalHeaderMegaMenu) originalHeaderMegaMenu.style.display = 'none'

//   // Show elements - Desktop
//   const alternativeHeaderMenu = document.querySelector('#header-nav-menu-group-alternative')
//   const alternativeHeaderMegaMenu = document.querySelector('#header-mega-menu-group-alternative')
//   if (alternativeHeaderMenu) alternativeHeaderMenu.style.display = 'flex'
//   if (alternativeHeaderMegaMenu) alternativeHeaderMegaMenu.style.display = 'block'

//   // Update header with class to use alternative design
//   const headerSectionElement = document.querySelector('.shopify-section-group-header-group.section-header')
//   if (headerSectionElement) headerSectionElement.classList.add('header-with-experiment-active')

//   // Hide elements - Mobile
//     const originalHeaderMenuMobile = document.querySelector('#header-menu-group-original-mobile')
//   if (originalHeaderMenuMobile) originalHeaderMenuMobile.style.display = 'none'

//   // Show elements - Mobile
//   const alternativeHeaderMenuMobile = document.querySelector('#header-menu-group-alternative-mobile')
//   if (alternativeHeaderMenuMobile) alternativeHeaderMenuMobile.style.display = 'block'

// }

// Enhanced Cart Caching System
// Extends basic cart caching with advanced features and section-specific caching
window.CartCacheManager = {
  // Main cart data cache
  cartCache: { data: null, timestamp: 0, ttl: 500 },
  
  // Section-specific caches (for cart UI sections)
  sectionCaches: new Map(),
  
  // Cache configuration
  config: {
    defaultTTL: 500,        // Default 500ms for mutations
    readOnlyTTL: 2000,      // 2s for read-only operations
    sectionTTL: 1000,       // 1s for cart sections
    maxSectionCaches: 10    // Limit section cache size
  },
  
  // Get cart data with configurable TTL
  async getCart(forceRefresh = false, operation = 'default') {
    const now = Date.now();
    const ttl = this.getTTLForOperation(operation);
    
    // Return cached data if valid
    if (!forceRefresh && 
        this.cartCache.data && 
        (now - this.cartCache.timestamp) < ttl) {
      console.log(`🎯 CartCacheManager: Returning cached cart data (${operation}, TTL: ${ttl}ms)`);
      return this.cartCache.data;
    }
    
    try {
      console.log(`🌐 CartCacheManager: Fetching fresh cart data (${operation})`);
      const response = await fetch('/cart.js');
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const data = await response.json();
      
      // Update cache with appropriate TTL
      this.cartCache = { 
        data, 
        timestamp: now, 
        ttl
      };
      
      console.log(`✅ CartCacheManager: Fresh cart data cached (TTL: ${ttl}ms)`);
      return data;
    } catch (error) {
      console.error('❌ CartCacheManager: Error fetching cart:', error);
      
      // Return stale cache if available during error
      if (this.cartCache.data) {
        console.log('⚠️  CartCacheManager: Returning stale cache due to fetch error');
        return this.cartCache.data;
      }
      
      throw error;
    }
  },
  
  // Get TTL based on operation type
  getTTLForOperation(operation) {
    switch (operation) {
      case 'read-only':
      case 'condition-check':
      case 'display':
        return this.config.readOnlyTTL;
      case 'mutation':
      case 'update':
        return this.config.defaultTTL;
      default:
        return this.config.defaultTTL;
    }
  },
  
  // Cache cart sections separately
  async getCartSection(sectionId, sectionsToFetch) {
    const now = Date.now();
    const cacheKey = `${sectionId}-${sectionsToFetch.join(',')}`;
    const cached = this.sectionCaches.get(cacheKey);
    
    // Return cached section if valid
    if (cached && (now - cached.timestamp) < this.config.sectionTTL) {
      console.log(`🎯 CartCacheManager: Returning cached section: ${sectionId}`);
      return cached.data;
    }
    
    try {
      console.log(`🌐 CartCacheManager: Fetching cart sections: ${sectionsToFetch.join(',')}`);
      const response = await fetch(`${routes.cart_url}?sections=${sectionsToFetch.join(',')}`);
      const data = await response.json();
      
      // Cache the section data
      this.sectionCaches.set(cacheKey, {
        data,
        timestamp: now
      });
      
      // Limit cache size
      this.cleanupSectionCaches();
      
      console.log(`✅ CartCacheManager: Section data cached: ${sectionId}`);
      return data;
    } catch (error) {
      console.error(`❌ CartCacheManager: Error fetching section ${sectionId}:`, error);
      
      // Return stale cache if available
      if (cached) {
        console.log(`⚠️  CartCacheManager: Returning stale section cache: ${sectionId}`);
        return cached.data;
      }
      
      throw error;
    }
  },
  
  // Cleanup old section caches
  cleanupSectionCaches() {
    if (this.sectionCaches.size <= this.config.maxSectionCaches) return;
    
    const entries = Array.from(this.sectionCaches.entries());
    entries.sort((a, b) => a[1].timestamp - b[1].timestamp);
    
    // Remove oldest entries
    const toRemove = entries.slice(0, entries.length - this.config.maxSectionCaches);
    toRemove.forEach(([key]) => {
      this.sectionCaches.delete(key);
    });
    
    console.log(`🧹 CartCacheManager: Cleaned up ${toRemove.length} old section caches`);
  },
  
  // Warm cart cache on page load
  async warmCache() {
    try {
      console.log('🔥 CartCacheManager: Warming cart cache...');
      await this.getCart(true, 'cache-warming');
      console.log('✅ CartCacheManager: Cache warmed successfully');
    } catch (error) {
      console.error('❌ CartCacheManager: Cache warming failed:', error);
    }
  },
  
  // Invalidate all caches
  invalidateAll() {
    console.log('🗑️ CartCacheManager: Invalidating all caches');
    this.cartCache = { data: null, timestamp: 0, ttl: this.config.defaultTTL };
    this.sectionCaches.clear();
  },
  
  // Invalidate specific section cache
  invalidateSection(sectionId) {
    console.log(`🗑️ CartCacheManager: Invalidating section cache: ${sectionId}`);
    const keysToDelete = Array.from(this.sectionCaches.keys())
      .filter(key => key.startsWith(`${sectionId}-`));
    
    keysToDelete.forEach(key => this.sectionCaches.delete(key));
  },
  
  // Get cache statistics
  getCacheStats() {
    const now = Date.now();
    return {
      cartCache: {
        exists: !!this.cartCache.data,
        age: this.cartCache.data ? now - this.cartCache.timestamp : 0,
        ttl: this.cartCache.ttl,
        isStale: this.cartCache.data ? (now - this.cartCache.timestamp) > this.cartCache.ttl : false
      },
      sectionCaches: {
        count: this.sectionCaches.size,
        keys: Array.from(this.sectionCaches.keys()),
        totalSize: this.sectionCaches.size
      }
    };
  }
};

// Update the global getCart to use enhanced caching
window.getCart = async (forceRefresh = false, operation = 'default') => {
  return window.CartCacheManager.getCart(forceRefresh, operation);
};

// Update invalidateCartCache to use enhanced manager
window.invalidateCartCache = () => {
  window.CartCacheManager.invalidateAll();
};

// Cart update deduplication and batching system
window.cartUpdateManager = {
  isUpdating: false,
  updateQueue: [],
  batchWindow: 100, // ms
  lastUpdate: 0,
  
  async executeUpdate(updateFn, source = 'unknown') {
    const now = Date.now();
    
    // For certain sources, bypass the queue to ensure immediate execution
    const immediateExecution = [
      'cart-items',
      'cart-drawer', 
      'product-form',
      'user-interaction',
      'quantity-update',
      'item-removal',
      'item-addition'
    ];
    
    if (immediateExecution.some(s => source.includes(s))) {
      console.log(`⚡ Immediate execution for ${source} - bypassing queue`);
      return this.executeImmediate(updateFn, source);
    }
    
    // If we're already updating, queue this request
    if (this.isUpdating) {
      console.log(`🔄 Cart update queued from ${source} - already updating`);
      return new Promise((resolve) => {
        this.updateQueue.push({ updateFn, source, resolve });
      });
    }
    
    // If recent update within batch window, defer only for batching operations
    if (now - this.lastUpdate < this.batchWindow && source.includes('batch')) {
      console.log(`⏱️ Cart update deferred from ${source} - within batch window`);
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(this.executeUpdate(updateFn, source));
        }, this.batchWindow - (now - this.lastUpdate));
      });
    }
    
    return this.executeImmediate(updateFn, source);
  },
  
  async executeImmediate(updateFn, source) {
    this.isUpdating = true;
    this.lastUpdate = Date.now();
    console.log(`🚀 Executing cart update from ${source}`);
    
    try {
      const result = await updateFn();
      
      // Immediately invalidate caches after successful update
      if (window.CartCacheManager) {
        window.CartCacheManager.invalidateAll();
        console.log('🗑️ Cart caches invalidated after update');
      }
      
      // Process any queued updates
      if (this.updateQueue.length > 0) {
        console.log(`📋 Processing ${this.updateQueue.length} queued cart updates`);
        const queued = this.updateQueue.splice(0); // Clear queue
        
        // Execute the most recent queued update and resolve all promises
        if (queued.length > 0) {
          const latestUpdate = queued[queued.length - 1];
          const queuedResult = await latestUpdate.updateFn();
          
          // Resolve all queued promises with the latest result
          queued.forEach(item => item.resolve(queuedResult));
        }
      }
      
      return result;
    } catch (error) {
      console.error('❌ Cart update failed:', error);
      throw error;
    } finally {
      this.isUpdating = false;
      console.log('✅ Cart update manager ready for next update');
    }
  }
};

// Illegal Item Management System
// Centralizes illegal item detection and removal logic with caching
window.IllegalItemManager = {
  // Configuration for illegal items
  config: {
    variantIds: [
      '41932804653169'  // App Exclusive 54 Thrones variant
    ],
    productIds: [
      '7362213970033',  // Free Gift RMS Beauty product  
      '7373764755569'   // App Exclusive 54 Thrones product
    ],
    vendors: [
      'Free Gift'
    ]
  },
  
  // Cache for detection results
  cache: {
    cartHash: null,
    illegalItems: null,
    timestamp: 0,
    ttl: 1000 // 1 second cache
  },
  
  // Check if an item should be removed
  shouldRemoveItem(item) {
    const variantId = String(item.variant_id || item.variantId);
    const productId = String(item.product_id || item.productId);
    const vendor = item.vendor || '';
    
    return (
      this.config.variantIds.includes(variantId) ||
      this.config.productIds.includes(productId) ||
      this.config.vendors.includes(vendor)
    );
  },
  
  // Check HTML element for illegal items
  shouldRemoveHTMLItem(element) {
    const variantId = element.getAttribute('data-variant-id');
    const isGiftProduct = element.hasAttribute('data-gift-product');
    const vendorElement = element.querySelector('.caption-with-letter-spacing');
    const vendor = vendorElement ? vendorElement.textContent.trim() : '';
    
    return (
      this.config.variantIds.includes(String(variantId)) ||
      this.config.vendors.includes(vendor) ||
      (isGiftProduct && this.config.vendors.includes('Free Gift'))
    );
  },
  
  // Get cart hash for cache invalidation
  getCartHash(cartData) {
    if (!cartData?.items) return '';
    return cartData.items.map(item => `${item.variant_id}-${item.quantity}`).join('|');
  },
  
  // Detect illegal items with caching
  async detectIllegalItems(cartData = null, forceRefresh = false) {
    const now = Date.now();
    
    // Get cart data if not provided
    if (!cartData) {
      cartData = await window.getCart(forceRefresh);
    }
    
    if (!cartData?.items?.length) {
      return [];
    }
    
    const cartHash = this.getCartHash(cartData);
    
    // Return cached result if valid
    if (!forceRefresh && 
        this.cache.cartHash === cartHash && 
        this.cache.illegalItems &&
        (now - this.cache.timestamp) < this.cache.ttl) {
      console.log('🎯 IllegalItemManager: Returning cached detection result');
      return this.cache.illegalItems;
    }
    
    console.log('🔍 IllegalItemManager: Detecting illegal items');
    const illegalItems = [];
    
    for (const item of cartData.items) {
      if (this.shouldRemoveItem(item)) {
        console.log(`🚫 Illegal item detected: ${item.product_title}`);
        illegalItems.push({
          variantId: String(item.variant_id),
          productId: String(item.product_id),
          title: item.product_title,
          vendor: item.vendor,
          reason: this.getRemovalReason(item)
        });
      }
    }
    
    // Update cache
    this.cache = {
      cartHash,
      illegalItems,
      timestamp: now,
      ttl: this.cache.ttl
    };
    
    console.log(`🎯 IllegalItemManager: Found ${illegalItems.length} illegal items`);
    return illegalItems;
  },
  
  // Get reason for removal
  getRemovalReason(item) {
    const variantId = String(item.variant_id);
    const productId = String(item.product_id);
    const vendor = item.vendor;
    
    if (this.config.variantIds.includes(variantId)) return `Illegal variant: ${variantId}`;
    if (this.config.productIds.includes(productId)) return `Illegal product: ${productId}`;
    if (this.config.vendors.includes(vendor)) return `Illegal vendor: ${vendor}`;
    return 'Unknown reason';
  },
  
  // Detect illegal items in HTML content
  detectIllegalItemsInHTML(htmlContent) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    const cartItems = tempDiv.querySelectorAll('.cart-item[data-variant-id]');
    
    const illegalItems = [];
    cartItems.forEach(item => {
      if (this.shouldRemoveHTMLItem(item)) {
        const variantId = item.getAttribute('data-variant-id');
        const titleElement = item.querySelector('.cart-item__name');
        const title = titleElement ? titleElement.textContent.trim() : 'Unknown';
        
        illegalItems.push({
          variantId,
          title,
          element: item
        });
      }
    });
    
    return illegalItems;
  },
  
  // Batch remove illegal items
  async batchRemoveItems(illegalItems, removalFn) {
    if (!illegalItems.length) return;
    
    console.log(`🗑️ IllegalItemManager: Batch removing ${illegalItems.length} items`);
    
    // Use the cart update manager to coordinate removal
    return window.cartUpdateManager.executeUpdate(async () => {
      const removePromises = illegalItems.map(async item => {
        try {
          console.log(`Removing: ${item.title} (${item.reason || 'Illegal item'})`);
          await removalFn(item.variantId);
        } catch (error) {
          console.error(`Failed to remove ${item.title}:`, error);
        }
      });

      await Promise.all(removePromises);
      
      // Invalidate cache after removal
      this.invalidateCache();
      
      console.log('✅ IllegalItemManager: Batch removal complete');
    }, 'illegal-item-manager');
  },
  
  // Invalidate cache
  invalidateCache() {
    console.log('🗑️ IllegalItemManager: Cache invalidated');
    this.cache = {
      cartHash: null,
      illegalItems: null,
      timestamp: 0,
      ttl: this.cache.ttl
    };
  }
};

// Initialize cache warming on page load
document.addEventListener('DOMContentLoaded', () => {
  // Warm cache after a short delay to avoid blocking page load
  setTimeout(() => {
    window.CartCacheManager.warmCache();
  }, 1000);
});

// Also warm cache when cart operations are likely (on hover over cart icon)
document.addEventListener('DOMContentLoaded', () => {
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    let warmed = false;
    cartIcon.addEventListener('mouseenter', () => {
      if (!warmed) {
        console.log('🔥 Pre-warming cart cache on hover');
        window.CartCacheManager.warmCache();
        warmed = true;
      }
    }, { once: true });
  }
});

// Cart Batch Operations System
// Handles batching of cart operations within a time window for optimal performance
window.CartBatchOperations = {
  // Batch configuration
  config: {
    batchWindow: 200,      // ms - time window for batching operations
    maxBatchSize: 10,      // maximum operations per batch
    debounceWindow: 300    // ms - debounce rapid fire operations
  },
  
  // Active batches by operation type
  batches: {
    quantityUpdates: [],
    itemRemovals: [],
    itemAdditions: []
  },
  
  // Batch timers
  timers: {
    quantityUpdates: null,
    itemRemovals: null,
    itemAdditions: null
  },
  
  // Queue a quantity update operation
  queueQuantityUpdate(line, quantity, name, cartItemsInstance) {
    console.log(`📋 CartBatchOperations: Queuing quantity update - line: ${line}, quantity: ${quantity}`);
    
    const operation = {
      type: 'quantity',
      line,
      quantity,
      name,
      cartItemsInstance,
      timestamp: Date.now()
    };
    
    // Check if this line already has a pending update
    const existingIndex = this.batches.quantityUpdates.findIndex(op => op.line === line);
    if (existingIndex >= 0) {
      console.log(`  - Replacing existing quantity update for line ${line}`);
      this.batches.quantityUpdates[existingIndex] = operation;
    } else {
      this.batches.quantityUpdates.push(operation);
    }
    
    this.scheduleBatchExecution('quantityUpdates');
  },
  
  // Queue an item removal operation
  queueItemRemoval(variantId, name, cartItemsInstance) {
    console.log(`📋 CartBatchOperations: Queuing item removal - variant: ${variantId}`);
    
    const operation = {
      type: 'removal',
      variantId,
      name,
      cartItemsInstance,
      timestamp: Date.now()
    };
    
    // Check if this variant already has a pending removal
    const existingIndex = this.batches.itemRemovals.findIndex(op => op.variantId === variantId);
    if (existingIndex >= 0) {
      console.log(`  - Replacing existing removal for variant ${variantId}`);
      this.batches.itemRemovals[existingIndex] = operation;
    } else {
      this.batches.itemRemovals.push(operation);
    }
    
    this.scheduleBatchExecution('itemRemovals');
  },
  
  // Queue an item addition operation
  queueItemAddition(variantId, quantity, name, cartItemsInstance) {
    console.log(`📋 CartBatchOperations: Queuing item addition - variant: ${variantId}, quantity: ${quantity}`);
    
    const operation = {
      type: 'addition',
      variantId,
      quantity,
      name,
      cartItemsInstance,
      timestamp: Date.now()
    };
    
    // For additions, combine quantities if same variant
    const existingIndex = this.batches.itemAdditions.findIndex(op => op.variantId === variantId);
    if (existingIndex >= 0) {
      console.log(`  - Combining addition quantities for variant ${variantId}`);
      this.batches.itemAdditions[existingIndex].quantity += quantity;
    } else {
      this.batches.itemAdditions.push(operation);
    }
    
    this.scheduleBatchExecution('itemAdditions');
  },
  
  // Schedule batch execution
  scheduleBatchExecution(batchType) {
    // Clear existing timer
    if (this.timers[batchType]) {
      clearTimeout(this.timers[batchType]);
    }
    
    // Check if batch is full and should execute immediately
    if (this.batches[batchType].length >= this.config.maxBatchSize) {
      console.log(`⚡ CartBatchOperations: Executing ${batchType} batch immediately (full)`);
      this.executeBatch(batchType);
      return;
    }
    
    // Schedule batch execution
    this.timers[batchType] = setTimeout(() => {
      if (this.batches[batchType].length > 0) {
        console.log(`⏰ CartBatchOperations: Executing ${batchType} batch (timeout)`);
        this.executeBatch(batchType);
      }
    }, this.config.batchWindow);
  },
  
  // Execute a batch of operations
  async executeBatch(batchType) {
    const batch = this.batches[batchType].splice(0); // Remove all items
    if (batch.length === 0) return;
    
    console.log(`🚀 CartBatchOperations: Executing batch of ${batch.length} ${batchType} operations`);
    
    // Clear timer
    if (this.timers[batchType]) {
      clearTimeout(this.timers[batchType]);
      this.timers[batchType] = null;
    }
    
    try {
      switch (batchType) {
        case 'quantityUpdates':
          await this.executeBatchQuantityUpdates(batch);
          break;
        case 'itemRemovals':
          await this.executeBatchItemRemovals(batch);
          break;
        case 'itemAdditions':
          await this.executeBatchItemAdditions(batch);
          break;
      }
    } catch (error) {
      console.error(`❌ CartBatchOperations: Error executing ${batchType} batch:`, error);
      
      // Fallback: execute operations individually
      console.log(`🔄 CartBatchOperations: Falling back to individual execution for ${batchType}`);
      await this.fallbackIndividualExecution(batch);
    }
  },
  
  // Execute batch quantity updates
  async executeBatchQuantityUpdates(batch) {
    // Group by cart instance to handle multiple carts
    const byInstance = new Map();
    batch.forEach(op => {
      if (!byInstance.has(op.cartItemsInstance)) {
        byInstance.set(op.cartItemsInstance, []);
      }
      byInstance.get(op.cartItemsInstance).push(op);
    });
    
    // Execute each instance's updates
    for (const [instance, operations] of byInstance) {
      await this.executeBatchForInstance(instance, operations);
    }
  },
  
  // Execute batch for a specific cart instance
  async executeBatchForInstance(cartInstance, operations) {
    console.log(`  - Executing ${operations.length} operations for cart instance`);
    
    // Use cart update manager to coordinate
    return window.cartUpdateManager.executeUpdate(async () => {
      // Execute all operations in parallel
      const promises = operations.map(async op => {
        try {
          await cartInstance.updateQuantity(op.line, op.quantity, op.name);
        } catch (error) {
          console.error(`Failed to update line ${op.line}:`, error);
        }
      });
      
      await Promise.all(promises);
      console.log(`  - ✅ Completed batch for cart instance`);
      
    }, 'cart-batch-operations');
  },
  
  // Execute batch item removals
  async executeBatchItemRemovals(batch) {
    // Use cart update manager to coordinate
    return window.cartUpdateManager.executeUpdate(async () => {
      const promises = batch.map(async op => {
        try {
          await op.cartItemsInstance.removeItemSimple(op.variantId, `${op.name}-batch`);
        } catch (error) {
          console.error(`Failed to remove variant ${op.variantId}:`, error);
        }
      });
      
      await Promise.all(promises);
      console.log(`  - ✅ Completed batch removals`);
      
    }, 'cart-batch-removals');
  },
  
  // Execute batch item additions
  async executeBatchItemAdditions(batch) {
    // Use cart update manager to coordinate
    return window.cartUpdateManager.executeUpdate(async () => {
      const promises = batch.map(async op => {
        try {
          await op.cartItemsInstance.addItemSimple(op.variantId, op.quantity, `${op.name}-batch`);
        } catch (error) {
          console.error(`Failed to add variant ${op.variantId}:`, error);
        }
      });
      
      await Promise.all(promises);
      console.log(`  - ✅ Completed batch additions`);
      
    }, 'cart-batch-additions');
  },
  
  // Fallback to individual execution
  async fallbackIndividualExecution(batch) {
    for (const operation of batch) {
      try {
        switch (operation.type) {
          case 'quantity':
            await operation.cartItemsInstance.updateQuantity(operation.line, operation.quantity, operation.name);
            break;
          case 'removal':
            await operation.cartItemsInstance.removeItemSimple(operation.variantId, operation.name);
            break;
          case 'addition':
            await operation.cartItemsInstance.addItemSimple(operation.variantId, operation.quantity, operation.name);
            break;
        }
        
        // Small delay between operations
        await new Promise(resolve => setTimeout(resolve, 50));
      } catch (error) {
        console.error(`❌ CartBatchOperations: Fallback operation failed:`, error);
      }
    }
  },
  
  // Get batch statistics
  getBatchStats() {
    return {
      quantityUpdates: this.batches.quantityUpdates.length,
      itemRemovals: this.batches.itemRemovals.length,
      itemAdditions: this.batches.itemAdditions.length,
      activeTimers: Object.values(this.timers).filter(timer => timer !== null).length
    };
  },
  
  // Clear all batches (useful for testing or emergency situations)
  clearAllBatches() {
    console.log('🧹 CartBatchOperations: Clearing all batches');
    Object.keys(this.batches).forEach(key => {
      this.batches[key] = [];
    });
    Object.keys(this.timers).forEach(key => {
      if (this.timers[key]) {
        clearTimeout(this.timers[key]);
        this.timers[key] = null;
      }
    });
  }
};
